import { createRedactor } from '@nerdwallet/redact';
const redactor = createRedactor({});
export default redactor;
